import React from 'react';

const items = [
  { key: 'journal', label: 'Journal', icon: (
    <svg xmlns="http://www.w3.org/2000/svg" className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 20l9-5-9-5-9 5 9 5z"/><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 12l9-5-9-5-9 5 9 5z"/><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 12v8"/></svg>
  ) },
  { key: 'prompts', label: 'Prompts', icon: (
    <svg xmlns="http://www.w3.org/2000/svg" className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"/></svg>
  ) },
  { key: 'schedule', label: 'Schedule', icon: (
    <svg xmlns="http://www.w3.org/2000/svg" className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor"><rect x="3" y="4" width="18" height="18" rx="2" ry="2"/><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M16 2v4M8 2v4M3 10h18"/></svg>
  ) },
  { key: 'previous', label: 'Previous', icon: (
    <svg xmlns="http://www.w3.org/2000/svg" className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4l3 3"/><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M20.4 15.9A8 8 0 1116 3.6"/></svg>
  ) },
];

export default function JournalBottomNav({ active, onSelect }) {
  return (
    <nav className="md:hidden fixed bottom-0 inset-x-0 bg-background-light dark:bg-background-dark border-t border-neutral z-40 pb-[env(safe-area-inset-bottom)]">
      <ul className="flex justify-around py-2">
        {items.map(item => (
          <li key={item.key}>
            <button
              onClick={() => onSelect(item.key)}
              className={`flex flex-col items-center text-xs ${active === item.key ? 'text-primary font-semibold' : 'text-neutral'}`}
              aria-current={active === item.key ? 'page' : undefined}
            >
              {item.icon}
              <span className="mt-1">{item.label}</span>
            </button>
          </li>
        ))}
      </ul>
    </nav>
  );
}
